export default __webpack_public_path__ + "static/mov_bbb-2c92d01256c8f29e1b68c92060ef5a0f.mp4";